export const tableDataZh = [{

}]

export const tableDataEn = [
  {
    item: 'Branding on countdown at Charity Night',
    value: '5,000 USD',
    note: 'Exclusive',
    imgUrl: '10.gif',
  },
  {
    item: 'Branding on bottled water',
    value: '3,000 USD',
    note: 'Exclusive',
    imgUrl: '3.jpg',
  },
  {
    item: 'Branding on wineglass at Charity Night',
    value: '2,500 USD',
    note: 'Exclusive',
    imgUrl: '9.jpg',
  },
  {
    item: 'Branding on souvenir',
    value: '2,000 USD',
    note: 'Exclusive',
    imgUrl: '1.jpg',
  },
  {
    item: 'Branding on our welcome package',
    value: '2,000 USD',
    note: 'Exclusive',
    imgUrl: '2.jpg',
  },
  {
    item: 'Branding on Wechat Moments - 3*iPhone14 for 3 winners',
    value: '3,000 USD',
    note: 'Exclusive',
    imgUrl: '',
  },
  {
    item: 'Branding on tea break (Day 2)',
    value: '1,000 USD',
    note: 'Exclusive',
    imgUrl: '8.jpg',
  },
  {
    item: 'Branding on tea break (Day 3)',
    value: '1,000 USD',
    note: 'Exclusive',
    imgUrl: '8.jpg',
  },
  {
    item: 'Advertising on event Mini APP',
    value: '1,500 USD/slot',
    note: 'Maximum 3 slots',
    imgUrl: '4.gif',
  },
  {
    item: 'Branding on supply station at training room (Day 2)',
    value: '1,500 USD/slot',
    note: 'Maximum 3 slots',
    imgUrl: '7.jpg',
  },
  {
    item: 'Branding on supply station at training room (Day 3)',
    value: '1,500 USD/slot',
    note: 'Maximum 3 slots',
    imgUrl: '7.jpg',
  },
  {
    item: 'Keynote speech - 30 mins each',
    value: '1,000 USD/slot',
    note: 'Maximum 4 slots',
    imgUrl: '',
  },
]